import { render, staticRenderFns } from "./Fpo_band.vue?vue&type=template&id=e21dc4fa&scoped=true"
import script from "./Fpo_band.vue?vue&type=script&lang=js"
export * from "./Fpo_band.vue?vue&type=script&lang=js"
import style0 from "./Fpo_band.vue?vue&type=style&index=0&id=e21dc4fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21dc4fa",
  null
  
)

export default component.exports